BookingsEditDoneController.$inject = [
    '$scope',
    'alerts',
    'Time',
    '$uibModal',
    'User',
    'Backoffice',
    'disabled_features',
];

/* @ngInject */
function BookingsEditDoneController(
    $scope,
    alerts,
    Time,
    $uibModal,
    User,
    Backoffice,
    disabled_features,
) {
    var vm = this;

    var $parent = $scope.$parent.vm;

    var booking = $parent.booking;
    vm.save_cash_booking_date = true;
    vm.loading = false;
    vm.loaded = false;
    // vm.balance = booking.attrs.balance;
    // vm.balance_abs = Math.abs(booking.attrs.balance);
    // vm.balance = vm.online_payment ? booking.attrs.balance - vm.online_payment.amount : booking.attrs.balance;
    // vm.balance_abs = Math.abs(vm.online_payment ? booking.attrs.balance - vm.online_payment.amount : booking.attrs.balance);
    // vm.partial_payment = vm.online_payment ? booking.attrs.balance - vm.online_payment.amount : 0;
    vm.online_payment = booking.payment ? booking.payment : null;
    vm.cd_offline_balance = vm.online_payment && booking.payment.isCapture === true ? booking.attrs.balance - vm.online_payment.amount : booking.attrs.balance;
    vm.balance = vm.cd_offline_balance;
    vm.balance_abs = Math.abs(vm.cd_offline_balance);
    vm.partial_payment = parseFloat(vm.online_payment ? vm.cd_offline_balance : 0);
    vm.can_use_balance = false;
    vm.use_balance = true;
    vm.price = booking.getPrice();
    vm.booking_date = booking.done?.datetime;
    vm.qualifications = null;
    vm.payed = 0;
    vm.paying = null;
    vm.owes = 0;
    vm.canSave = true;
    vm.canCashout = true;
    vm.finished = false;
    vm.save_remains = false;
    vm.booking_state = '';
    vm.payment_type = 'cash';
    vm.totalPrice = 0;
    vm.discount_amount = booking?.done?.discount_amount || '';
    vm.booking_done = booking?.done;
    vm.all_movements = null;
    vm.update = function (data) {
        alerts
            .verifyCode(null, null, User)
            .then(
                save.bind(null, {
                    ...data,
                    should_imact_in_cash_movements: false,
                }),
            )
            .catch((error) => alerts.errorHandler(error));
    };
    vm.save = function () {
        alerts
            .verifyCode(null, null, User)
            .then(
                save.bind(null, {
                    finished: false,
                    payed: vm.paying,
                    use_deposit: vm.use_balance,
                    save_remains: vm.save_remains,
                    qualifications: vm.qualifications,
                }),
            )
            .catch((error) => alerts.errorHandler(error));
    };
    vm.load = load;

    vm.cashout = function () {
        var data = {
            finished: true,
            payed: vm.paying,
            use_deposit: vm.use_balance,
            save_remains: vm.save_remains,
            payment_type: vm.payment_type,
            qualifications: vm.qualifications ?? {
                punctuality: true,
                facilities: true,
                payment: true,
            },
            discount_amount: Number(vm.discount_amount),
            balance_amount: Number(vm.balance),
        };

        switch (vm.booking_state) {
            case 'skip':
                data.skip = true;
                break;
            case 'cancel':
                data.last_booking = true;
                break;
        }
        alerts
            .verifyCode(null, null, User)
            .then(save.bind(null, data))
            .catch((error) => {
                resetCashoutField();
                alerts.errorHandler(error);
            });
    };
    vm.qualificate = qualificate;

    $scope.$watchGroup(
        [
            'done.price',
            'done.use_balance',
            'done.paying',
            'done.balance',
            'done.payed',
            'done.totalMovements',
            'done.discount_amount',
        ],
        function () {
            vm.owes =
                vm.price +
                vm.totalMovements -
                vm.paying -
                Number(vm.discount_amount) -
                (vm.use_balance ? vm.balance : 0) -
                vm.payed;

            vm.totalPrice = vm.price + vm.totalMovements;
        },
    );

    $scope.$watchGroup(['done.owes', 'done.save_remains'], function () {
        vm.canCashout =
            (!isNaN(vm.owes) &&
                booking.isFixed &&
                (vm.owes === 0 || vm.save_remains)) ||
            (!booking.isFixed &&
                (vm.owes === 0 || (vm.owes > 0 && vm.save_remains)));
    });

    $scope.$watch('done.price', function(newVal) {
        if(newVal) {
            vm.priceWithCents = parseFloat(newVal).toFixed(2)
        }
    });

    $scope.$watch('done.balance_abs', function(newVal) {
        if(newVal) {
            vm.balance_abs = parseFloat(newVal).toFixed(2)
        }
    });

    activate();

    ////////////////////////////////
    ///
    ////////////////////////////////

    function activate() {
        load();
    }

    function update() {
        var done = $parent.booking.done;

        vm.movements = done.movements;
        vm.totalMovements = done.movements.reduce(
            (sum, item) => sum + item.total,
            0,
        );

        // vm.payed = done.price - done.discount_amount - done.owes;
        vm.payed = done.price - done.discount_amount - done.owes + vm.partial_payment;
        vm.price = Number(done.price);
        vm.finished = done.finished;
        vm.balance = booking.getPayedAdvance();
        if (done.qualifications) {
            vm.qualifications = done.qualifications;
        }
        vm.balance_abs = Math.abs(vm.balance);
        vm.can_use_balance = booking.isFixed() && vm.balance > 0;
        vm.use_balance =
            !booking.hasPayment() && (!booking.isFixed() || vm.balance < 0);
        vm.owes = done.owes - (vm.use_balance ? vm.balance : 0) - vm.payed;

        vm.booking_date = done.datetime;
        vm.booking = $parent.booking;
    }

    function resetCashoutField() {
        vm.paying = null;
        update();
    }

    async function save(data, {code, user_info}) {
        vm.all_movements = vm.movements;
        data.code = code;
        data.date = vm.save_cash_booking_date ? $parent.getDate() : Time.moment().toISOString(true);
        vm.payed = data.payed;

        if (!data.qualifications) {
            delete data.qualifications;
        }
        vm.loading = true;

        const should_imact_in_cash_movements =
            data.should_imact_in_cash_movements ?? true;

       

        try {
            if (should_imact_in_cash_movements) {
                var cash_movement_result = (await registerCartsMovements(user_info))
                    .cash_movements;
            }

            try {
                const booking = await $parent.booking
                    .api()
                    .one('done', $parent.booking.done.id)
                    .customPUT(data);

                if (booking) {
                    $parent.booking.done = booking.booking_done;
                    $parent.booking.attrs.balance = booking.balance;
                    update();

                    if (data.finished) {
                        alerts.success(
                            '¡Exito!',
                            'Se cobró la reserva correctamente',
                        );
                        $parent.close(true);
                    }

                    return booking;
                }
            } catch (error) {
                const cash_movements_ids = cash_movement_result.map(
                    (movement) => ({
                        id: movement.id,
                    }),
                );
                await Backoffice.api.undoRegisterCarts({
                    cash_movements: cash_movements_ids,
                    stock_movements: [],
                });
                throw new Error(
                    'A ocurrido un error inesperado. Intente nuevamente',
                );
            }
        } catch (error) {
            //Sin el then, se comporta extraño el finally
            console.log(error);
            alerts
                .error(
                    '¡Error!',
                    '¡Ha sucedido un error!. Intente nuevamente o comuniquese con soporte.',
                )
                .then(() => {});
        } finally {
            vm.loading = false;
            resetCashoutField();
        }
    }

    function registerCartsMovements(user_info) {
        const created_by = {
            user: user_info?.name ?? User.data.name,
            player: vm.booking.attrs.user.name,
        };

        const concept_details = {
            booking_date: Time.moment(vm.booking_date + ':00').toISOString(true),
            court: vm.booking.court.name,
            booking_id: vm.booking.id,
        };

        const cash_movements = [];

        let comment_discount = vm.discount_amount
            ? `- Se aplicó un descuento de $${vm.discount_amount} \n\n`
            : '';


        cash_movements.push({
            value: (vm.payed - vm.totalMovements) * 100,
            concept: 'Cobro de turno',
            payment_method: vm.payment_type,
            comment: comment_discount + (vm.booking.note?.value?.text || ''),
            created_by: JSON.stringify(created_by),
            movement_datetime: vm.save_cash_booking_date
                ? concept_details.booking_date
                : Time.moment().toISOString(true), // Usar offset local (-3) en lugar de UTC
            concept_details: JSON.stringify(concept_details),
            quantity: 0,
            item_id: null,
        });

        if (vm.all_movements.length) {
            vm.all_movements.forEach((mov) => {
                if (!mov.payed)
                    cash_movements.push({
                        value: mov.total * 100,
                        concept: mov.concept,
                        payment_method: vm.payment_type,
                        comment: '',
                        created_by: JSON.stringify(created_by),
                        movement_datetime: vm.save_cash_booking_date
                            ? concept_details.booking_date
                            : Time.moment().toISOString(true), // Usar offset local (-3) en lugar de UTC
                        concept_details: JSON.stringify(concept_details),
                        quantity: mov.quantity,
                        item_id: mov.item_id,
                    });
            });
        } else {
            update();
        }
        return Backoffice.api.registerCarts({
            stock_movements: [],
            cash_movements,
        });
    }

    function load() {
        if (vm.loaded) {
            update();
            return;
        }

        var data = {
            date: $parent.getDate(),
        };

        vm.loading = true;
        booking
            .api()
            .customGET('done', data)
            .then(function (done) {
                vm.loading = false;
                vm.loaded = true;
                $parent.booking.done = done;
                update();
            })
            .catch(function (response) {
                alerts.errorHandler(response);
                $parent.infoMode();
            });
    }

    function qualificate() {
        $uibModal
            .open({
                template: require('../../../views/booking/edit.qualifications.modal.html'),
                size: 'md',
                backdrop: false,
                windowClass: 'zindex',
                controller: 'BookingsEditQualificationsController',
                controllerAs: 'vm',
                bindToController: true,
                resolve: {
                    deps: {
                        qualifications: vm.qualifications,
                    },
                },
            })
            .result.then(function (qualifications) {
                vm.qualifications = qualifications;
            })
            .catch(angular.noop);
    }
}

export default BookingsEditDoneController;
